import { mapEventType } from '../../helper/map-event-type';
export const eventType = config => {
  return {
    'event:type': mapEventType(config.type)
  };
};